document.addEventListener("DOMContentLoaded", function () {

  let lastVariantId = null;

  document.addEventListener("change", function (e) {

    const target = e.target;

    // Sirf actual variant id input par run hoga
    if (target.name !== "id") return;

    setTimeout(function () {

      const variantId = target.value;

      if (!variantId) return;

      // duplicate run prevent
      if (lastVariantId === variantId) return;
      lastVariantId = variantId;

      const customElement = document.querySelector(".axt-cp-custom");

      if (!customElement) return;

      const oldVariant = customElement.getAttribute("axt-cp-variant-id");

      if (oldVariant) {
        customElement.classList.remove(oldVariant);
      }

      customElement.classList.add(variantId);
      customElement.setAttribute("axt-cp-variant-id", variantId);

      console.log("Variant updated:", variantId);

    }, 800);

  });

});